<template>
  <div class="rule-box">
   <v-head :title="title"></v-head>
   <div class="content">
    <p>注：文件大小不超过6M，支持 jpg 和 png 格式；</p>
    <h4>上传证明材料 <span>*职称证明材料请上传图片</span></h4>
       <van-uploader
               v-model="fileList"
               :after-read="afterTitleFile"
               @delete="delFile('titleFileId')"
               :max-count="1"
       />
    <h4>2寸证件照<span>*照片仅用于制作会员证书</span></h4>
       <van-uploader
               v-model="fileList2"
               :after-read="afterPortraitFile"
               @delete="delFile('portraitId')"
               :max-count="1"
       />
    <div class="buton">
      <van-button type="primary" size="large" @click="save">保存</van-button>
    </div>
   </div>

  </div>
</template>

<script>
import vHead from "../../components/Subhead.vue";
import { Uploader,Toast,Button } from "vant";
import { uploadFile, delFile } from "@/api/upload";
import { mapState} from "vuex";
import { registerMemberEdit } from "@/api/login";

export default {
  data() {
    return {
     fileList: [],
     fileList2: [],
     photoList:[],
     uploadFileId:null,
     titleFileId: null,
     portraitId: null,
     title:"附件上传"
    };
  },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button
  },
  methods: {
      beforeRead(file) {
          if (file.size / 1024 > 1024 * 6) {
              Toast("上传头像图片大小不能超过 6M!");
              return false;
          }
          return true;
      },
      delFile(type) {
          let id = this[type];
          this[type] = null;
          if (id) {
              let params = {
                  id
              };

              delFile(params).then(res => {
                  if (res.success) {
                      Toast("删除成功");
                  } else {
                      Toast("删除失败");
                  }
              });
          }
      },
      afterTitleFile(fileObj) {
          let params = new FormData();
          params.append("file", fileObj.file);
          uploadFile(params).then(res => {
              if (res.success) {
                  this.titleFileId = res.result.id;
                  Toast("上传成功");
              } else {
                  Toast("上传失败");
              }
          });
      },
      afterPortraitFile(fileObj) {
          let params = new FormData();
          params.append("file", fileObj.file);
          uploadFile(params).then(res => {
              if (res.success) {
                  this.portraitId = res.result.id;
                  Toast("上传成功");
              } else {
                  Toast("上传失败");
              }
          });
      },
      save(){
          if(this.titleFileId){
              this.userInfo.titleFileId = this.titleFileId;
          }
          if(this.portraitId){
               this.userInfo.portraitId = this.portraitId;
          }
          if(!this.portraitId||!this.titleFileId){
              Toast("请上传全部图片");
          }
          this.userInfo.birthday = this.changeTime(new Date(this.userInfo.birthday));
          registerMemberEdit(this.userInfo)
              .then(data => {
                  if (data.success) {
                      Toast("保存成功");
                       this.$router.push({ name: 'MemberCenter'});
                  } else {
                      Toast("保存失败");
                  }
              })
      },
      changeTime(time) {
          if (!time || time.length <= 0) {
              return time;
          }
          var y = time.getFullYear(),
              m = time.getMonth() + 1,
              d = time.getDate();

          if (m < 10) {
              m = "0" + m;
          }
          if (d < 10) {
              d = "0" + d;
          }
          return y + "-" + m + "-" + d;
      }
      },
    computed:{
        ...mapState(["userInfo"])
    }
};
</script>

<style lang="less" scoped>
p {
  margin-bottom: 10px;
}
b {
  font-weight: bold;
  margin-right: 10px;
}
ul {
  li {
    margin-bottom: 5px;
    line-height: 1.5;
  }
}
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.content{ 
    padding:20px;
    .van-button--large{    
      height:45px; line-height:35px; margin-top: 15px;
    }
  p{ font-size: 14px; color: #d64a4a; margin:10px 0;}
  h4{ 
    font-size: 15px; margin: 20px 0;
    span{color: #d64a4a;  font-size: 13px;}
   }
}
</style>

